/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mysessions1Inputs */

const zh_learn_mysessions1 = /** @type {(inputs: Learn_Mysessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的资源`)
};

const en_learn_mysessions1 = /** @type {(inputs: Learn_Mysessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Resources`)
};

const es_learn_mysessions1 = /** @type {(inputs: Learn_Mysessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis recursos`)
};

/**
* | output |
* | --- |
* | "My Resources" |
*
* @param {Learn_Mysessions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mysessions1 = /** @type {((inputs?: Learn_Mysessions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mysessions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mysessions1(inputs)
	if (locale === "en") return en_learn_mysessions1(inputs)
	return es_learn_mysessions1(inputs)
});
export { learn_mysessions1 as "learn_mySessions" }